<app-header></app-header>
<div class="container-fluid" style="min-height:87vh">

  @for (service of downServices; track service; let last = $last) {
    <div>
      <mat-expansion-panel hideToggle>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Latest Update {{ currentDate | date: 'dd/MM/yyyy' }}
          </mat-panel-title>
          <mat-panel-description>
            Submission Tool is currently down
          </mat-panel-description>
        </mat-expansion-panel-header>
        <p>Although you can still convert and validate your submission file, the {{ service }} Submission Tool is unavailable
          at the moment.</p>
        <p>
          Please come back at a later time or if you would like to contact helpdesk, send us an email on
          <a href="mailto:faang-dcc@ebi.ac.uk?Subject=Submission%20Tool%20Downtime" target="_top">
            <span class="emailStyle">faang-dcc&#64;ebi.ac.uk</span></a>.
        </p>
      </mat-expansion-panel>
    </div>
    @if (!last) { <hr> }
  }

  <!-- Dash App iframe -->
  <div class="beta-frame-wrapper">
    <iframe
      class="beta-frame"
      [src]="betaUrl"
      title="FAANG Validator"
      loading="lazy"
    ></iframe>
  </div>

</div>
